// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"ca4fc577","115":"565cbd3b","352":"ca4fc577","725":"ca4fc577","812":"994b2960","861":"ca4fc577"}[chunkId] + ".css";
};